import React from "react";
import { Divider } from "@mui/material";

const FormDivider: React.FC = () => (
  <Divider data-testid="form-divider" className="border-[#E6EDF2]" />
);

export default FormDivider;
